module.exports = __webpack_public_path__ + "img/relea.2c82d903.png";